import { StateNode } from "../../../tools/StateNode.mjs";
import { GeoShapeUtil } from "../GeoShapeUtil.mjs";
class Idle extends StateNode {
  static id = "idle";
  onPointerDown = (info) => {
    this.parent.transition("pointing", info);
  };
  onEnter = () => {
    this.editor.setCursor({ type: "cross" });
  };
  onKeyUp = (info) => {
    if (info.key === "Enter") {
      const shape = this.editor.onlySelectedShape;
      if (shape && this.editor.isShapeOfType(shape, GeoShapeUtil)) {
        this.editor.mark("editing shape");
        this.editor.setEditingId(shape.id);
        this.editor.setSelectedTool("select.editing_shape", {
          ...info,
          target: "shape",
          shape
        });
      }
    }
  };
  onCancel = () => {
    this.editor.setSelectedTool("select");
  };
}
export {
  Idle
};
//# sourceMappingURL=Idle.mjs.map
